import React from 'react';
import { useLanguage } from '../contexts/language';

export default function String({ s, l }) {
  const { content, language } = useLanguage();

  const string = React.useMemo(() => content(s, l ?? language), [s, l, language, content]);

  if (!string) {
    console.warn(`Missing content - string: ${s}, language: ${l ?? language}`);
  }

  return string ?? '';
}
